import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Dashboard from './pages/Dashboard';
import CallManagement from './pages/CallManagement';
import Transcriptions from './pages/Transcriptions';
import TranscriptViewer from './pages/TranscriptViewer';
import Summarizations from './pages/Summarizations';
import SummaryViewer from './pages/SummaryViewer';
import Connections from './pages/Connections';
import Login from './pages/Login';
import { setAuthToken } from './services/api';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize authentication on app start
    setAuthToken('4bd6852c-0162-40c3-9930-148617d5ea39');
  }, []);

  return (
    <Router>
      <div className="App" style={{ minHeight: '100vh', background: '#f8fafc' }}>
        <Navigation />
        <main>
                      <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/call-management" element={<CallManagement />} />
              <Route path="/transcriptions" element={<Transcriptions />} />
              <Route path="/transcript/:jobId" element={<TranscriptViewer />} />
              <Route path="/summarizations" element={<Summarizations />} />
              <Route path="/summary/:jobId" element={<SummaryViewer />} />
              <Route path="/connections" element={<Connections />} />
              <Route path="/login" element={<Login />} />
            {/* Fallback route */}
            <Route path="*" element={
              <div style={{ 
                minHeight: '100vh', 
                background: '#f8fafc', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' 
              }}>
                <div style={{ textAlign: 'center' }}>
                  <h1 style={{ 
                    fontSize: '2.25rem', 
                    fontWeight: '700', 
                    color: '#1e293b', 
                    marginBottom: '1rem' 
                  }}>
                    404 - Page Not Found
                  </h1>
                  <p style={{ 
                    color: '#64748b', 
                    marginBottom: '2rem' 
                  }}>
                    The page you're looking for doesn't exist.
                  </p>
                  <a 
                    href="/" 
                    className="btn btn-primary"
                  >
                    Go back to Dashboard
                  </a>
                </div>
              </div>
            } />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

export default App;
